var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      ref: "menu",
      attrs: {
        "close-on-content-click": false,
        "nudge-right": 40,
        "return-value": _vm.time,
        transition: "scale-transition",
        "offset-y": "",
        "max-width": "290px",
        "min-width": "290px",
      },
      on: {
        "update:returnValue": function ($event) {
          _vm.time = $event
        },
        "update:return-value": function ($event) {
          _vm.time = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                "BaseInputText",
                _vm._g(
                  _vm._b(
                    {
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.time,
                        callback: function ($$v) {
                          _vm.time = $$v
                        },
                        expression: "time",
                      },
                    },
                    "BaseInputText",
                    _vm.$attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _vm._v(" "),
      _vm.menu
        ? _c(
            "v-time-picker",
            {
              attrs: { "full-width": "" },
              model: {
                value: _vm.time,
                callback: function ($$v) {
                  _vm.time = $$v
                },
                expression: "time",
              },
            },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    color: "primary",
                    icon: "",
                    fab: "",
                    small: "",
                  },
                  on: { click: _vm.cancel },
                },
                [
                  _c("v-icon", { attrs: { color: "error" } }, [
                    _vm._v("mdi-close"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    color: "primary",
                    icon: "",
                    fab: "",
                    small: "",
                  },
                  on: { click: _vm.save },
                },
                [
                  _c("v-icon", { attrs: { color: "success" } }, [
                    _vm._v("mdi-check"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }